export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-[75vh] md:min-h-[85vh] flex items-center bg-[#0d1a2a] overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20modern%20law%20office%20interior%20with%20dark%20navy%20blue%20walls%20sophisticated%20legal%20workspace%20professional%20attorney%20office%20ambient%20lighting%20minimalist%20design%20contemporary%20furniture%20legal%20books%20wooden%20desk%20refined%20atmosphere&width=1920&height=1080&seq=hero001&orientation=landscape"
          alt="Estudio Jurídico VA - Oficina profesional"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#14253D]/95 via-[#14253D]/80 to-[#14253D]/50"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d1a2a] via-transparent to-[#14253D]/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-20 py-16 md:py-24 pt-24 md:pt-24">
        <div className="max-w-2xl space-y-5 md:space-y-6 text-left items-start">
          {/* Title */}
          <h1 className="text-3xl md:text-4xl lg:text-6xl font-serif font-bold text-white leading-[1.1] text-left">
            Asesoría Jurídica
          </h1>

          {/* Description */}
          <p className="text-white/70 text-base md:text-lg lg:text-xl leading-relaxed max-w-lg text-left">
            Servicios legales con atención personalizada
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-2 md:pt-4 justify-start">
            <button
              onClick={() => scrollToSection('contacto')}
              className="bg-[#B89A5A] text-[#14253D] px-6 md:px-8 py-3.5 md:py-4 rounded-full text-sm md:text-base font-semibold hover:bg-[#A68A4A] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Agendar Consulta
            </button>
            <button
              onClick={() => scrollToSection('servicios')}
              className="border border-white/30 text-white px-6 md:px-8 py-3.5 md:py-4 rounded-full text-sm md:text-base font-medium hover:border-[#B89A5A] hover:text-[#B89A5A] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Ver Servicios
            </button>
          </div>

          {/* Stats Row */}
          <div className="flex items-center gap-4 md:gap-8 pt-6 border-t border-white/10 justify-start">
            <div>
              <p className="text-[#B89A5A] text-2xl md:text-3xl font-serif font-bold">5+</p>
              <p className="text-white/60 text-xs md:text-sm">Años de experiencia</p>
            </div>
            <div className="w-px h-10 md:h-12 bg-white/15"></div>
            <div>
              <p className="text-[#B89A5A] text-2xl md:text-3xl font-serif font-bold">500+</p>
              <p className="text-white/60 text-xs md:text-sm">Casos resueltos</p>
            </div>
            <div className="w-px h-10 md:h-12 bg-white/15"></div>
            <div>
              <p className="text-[#B89A5A] text-2xl md:text-3xl font-serif font-bold">3</p>
              <p className="text-white/60 text-xs md:text-sm">Áreas de Especialización</p>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative curved shape at bottom */}
      <div className="absolute bottom-[-2px] left-0 right-0 w-full leading-[0]" style={{ overflow: 'visible' }}>
        <div className="relative" style={{ paddingTop: '20px' }}>
          <svg
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
            className="w-full h-[80px] md:h-[120px] relative"
            style={{ display: 'block', filter: 'drop-shadow(0 -6px 14px rgba(184, 154, 90, 0.4))' }}
          >
            <path d="M0,120 L0,40 Q360,0 720,40 T1440,40 L1440,120 Z" fill="#0d1a2a" />
          </svg>
        </div>
      </div>
    </section>
  );
}